@if(segment()){
<header>
    <button (click)="play.emit(segment()!)">lire la réplique</button>
    <div class="timer">debute à {{segment()?.start}}</div>
    <div class="timer">termine à {{segment()?.end}}</div>
</header>
<div class="trancription-editor-element">
    <div class="original">
        {{segment()!.text}}

        <span class="locked">
            <lucide-angular name="lock" size="16" />
            transcrit pas SVET</span>
    </div>
    <lucide-angular name="arrow-right" />
    <div class="edition">
        <textarea [value]="modifiedText()" (change)="textChange($event)"></textarea>
        <ul>
            <li class="danger" (click)="delete.emit()">supprimer</li>
            <li class="danger" (click)="cancel.emit()">annuler</li>
            <li (click)="onSave()">enregister</li>
        </ul>
    </div>
</div>
} @else {
<div class="advice">selectionnez une réplique pour la modifier.</div>
}